const emptyArray = ['', null, undefined];

export const validateMapping = (mapping, fields, clickedOnSave, isCustomCsv = false) => {        
    // For custom CSV, skip the "required field" validation but still validate the value field
    if (clickedOnSave && mapping.required && !isCustomCsv && emptyArray.includes(mapping.value)) {
        return 'Required field';
    }

    // Always validate the right side template syntax and field references
    const error = validateCorrectBracketsFields(mapping.value, fields);    
    
    return error ? error : '';
}

export const validateXmlMapping = (mapping, fields) => {    
    if (emptyArray.includes(mapping.attribute)) {
        return 'Attribute name is empty';
    }

    if (emptyArray.includes(mapping.value)) {
        return 'Value is empty';
    }

    const error = validateCorrectBracketsFields(mapping.value, fields);
    
    return error ? error : '';
}

const validateOperations = (fieldArea) => {
    const parts = fieldArea.split('|');
    // Skip first part (field name)
    const operations = parts.slice(1);
    
    for (let operation of operations) {
        if (!operation.trim()) {
            return 'Empty operation found';
        }
        
        // Basic validation for replace operation format
        if (operation.startsWith('replace:')) {
            const replaceParts = operation.split(':');
            if (replaceParts.length !== 3) {
                return 'Replace operation must have format: replace:from:to';
            }
        }
        // Add validation for other operations as needed
        // else if (operation.startsWith('lowercase')) {
        //     // No additional validation needed for lowercase
        // }
        // else if (operation.startsWith('uppercase')) {
        //     // No additional validation needed for uppercase
        // }
        // else if (operation.startsWith('trim')) {
        //     // No additional validation needed for trim
        // }
        // else {
        //     // Unknown operation - could warn or allow
        //     // return `Unknown operation: ${operation}`;
        // }
    }
    
    return null;
}

export const validateCorrectBracketsFields = (ruleString, fields) => {
    if (!ruleString) {
        return '';
    }
    
    let position = 0;
    let subString = ruleString;
    while (position > -1) {        
        let start = subString.indexOf('{{');
        let end = subString.indexOf('}}');

        if (start === -1 && end === -1) {
            return '';
        }

        if (start !== -1 && end === -1) {
            return 'Close bracket not found';
        }

        if (start === -1 && end !== -1) {
            return 'Open bracket not found';
        }

        const fieldArea = subString.substring(start + 2, end);
        
        // Extract field name (part before first pipe if operations exist)
        const fieldNamePart = fieldArea.includes('|') 
            ? fieldArea.substring(0, fieldArea.indexOf('|'))
            : fieldArea;

        const exist = fields.find(t => !t.dynamics && t.displayName === fieldNamePart);
        const dynamicExist = fields.find(t => t.dynamics === true && fieldNamePart.indexOf(t.name) === 0);

        let dynamicCorrect = false;
        if (dynamicExist) {
            dynamicCorrect = !!getSequenceNumberFromDynamicField(fieldNamePart);
        }

        if (!(exist || (dynamicExist && dynamicCorrect))) {
            return 'Product field not found';
        }

        // Validate operations if they exist
        if (fieldArea.includes('|')) {
            const operationsError = validateOperations(fieldArea);
            if (operationsError) {
                return operationsError;
            }
        }

        subString = subString.substring(end + 2, subString.length);
    }
}

export const changeFieldsDisplayNameWithId = (ruleString, fields = []) => {
    let position = 0;
    let subString = ruleString;
    let result = ruleString;
    while (position > -1) {        
        let start = subString.indexOf('{{');
        let end = subString.indexOf('}}');

        if ((start === -1 && end === -1) || (start !== -1 && end === -1) || (start === -1 && end !== -1)) {
            break;
        }

        const fieldArea = subString.substring(start + 2, end);
        
        // Split field name from operations
        const hasOperations = fieldArea.includes('|');
        const fieldNamePart = hasOperations 
            ? fieldArea.substring(0, fieldArea.indexOf('|'))
            : fieldArea;
        const operationsPart = hasOperations 
            ? fieldArea.substring(fieldArea.indexOf('|'))
            : '';
            
        const exist = fields.find(t => t.displayName === fieldNamePart);
        const dynamicExist = fields.find(t => t.dynamics === true && fieldNamePart.indexOf(t.name) === 0);

        if (exist && !exist.dynamics) {
            result = result.replace(fieldArea, exist.id + operationsPart);
        } else if (dynamicExist) {
            const idFromName = getSequenceNumberFromDynamicField(fieldNamePart);
            if (idFromName) {
                result = result.replace(fieldArea, dynamicExist.id.replace('[N]', idFromName) + operationsPart);
            } else {
                //ToDo: remove?
            }
        }

        subString = subString.substring(end + 2, subString.length);
    }
    return result;
}

export const changeFieldsIdWithDisplayName = (ruleString, fields = []) => {
    let position = 0;
    let subString = ruleString;
    let result = ruleString;
    while (position > -1) {        
        let start = subString.indexOf('{{');
        let end = subString.indexOf('}}');

        if ((start === -1 && end === -1) || (start !== -1 && end === -1) || (start === -1 && end !== -1)) {
            break;
        }

        const fieldArea = subString.substring(start + 2, end);
        
        // Split field ID from operations
        const hasOperations = fieldArea.includes('|');
        const fieldIdPart = hasOperations 
            ? fieldArea.substring(0, fieldArea.indexOf('|'))
            : fieldArea;
        const operationsPart = hasOperations 
            ? fieldArea.substring(fieldArea.indexOf('|'))
            : '';
            
        const exist = fields.find(t => t.id === fieldIdPart);

        if (exist) {
            result = result.replace(fieldArea, exist.displayName + operationsPart);
        } else {
            const idPart = fieldIdPart.substring(0, fieldIdPart.lastIndexOf('_'));
            const idFromName = fieldIdPart.substring(fieldIdPart.lastIndexOf('_') + 1, fieldIdPart.length);
            const dynamicExist = fields.find(t => t.id === idPart + '_[N]');
            if (dynamicExist) {
                result = result.replace(fieldArea, dynamicExist.name + ' ' + idFromName + operationsPart);
            }
        }

        subString = subString.substring(end + 2, subString.length);
    }
    return result;
}

export const getSequenceNumberFromDynamicField = (displayName) => {
    if (!displayName) {
        return undefined;
    }
    
    const parts = displayName.split(' ');

    if (parts.length < 2) {
        return undefined;
    }

    var reg = /^\d+$/;

    const last = parts[parts.length - 1];
    const isInteger = reg.test(last) && +last !== 0;
    const value = Number.parseInt(last);

    if (!isNaN(value) && isInteger) {
        return value;
    }

    return undefined;
}